export default __webpack_public_path__ + "assets/pdf/FT_ZNE.32905afe.pdf";